import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BaseBackResponse, SellerSummary } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.config}sellers/byid/${COMMON_QUERY_PARAMS.SELLER_ID}`;

export interface GetSellerByIdArgs {
  sellerId: string;
}

interface GetSellerByIdResponse extends BaseBackResponse {
  failure: false;
  value: SellerSummary;
}
interface GetSellerByIdResponseError extends BaseBackResponse {
  failure: true;
}

export const getSellerSummaryByIdRequest = (
  payload: GetSellerByIdArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, payload.sellerId),
  config: { method: SUPPORTED_METHODS.GET },
});

export default async function getSellerSummaryById(
  payload: GetSellerByIdArgs,
): Promise<GetSellerByIdResponse | GetSellerByIdResponseError> {
  try {
    return await executeQuery<GetSellerByIdResponse>(
      getSellerSummaryByIdRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
